import { Image, Box } from '@chakra-ui/react'
import React from 'react'

const DataNotFound = () => {
    return (
        <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
            -- No Data Found --
        </Box>
    )
}

export default DataNotFound
